angular.module('bizmetryApp').controller('ClientCreateDialogController', function (
    $scope, $q, $mdDialog, $timeout,
    profile, clientTypes, environments,
    ClientService, dialogService, ReferenceDataService, TemplateInstanceService
) {
    var vm = this;

    // ===== RAW ENVIRONMENTS (from locals) =====
    vm.environments = (environments || []).map(function (env) {
        return {
            id: env.id,
            name: env.name,
            envType: env.envType || null,
            envTypeId: env.envTypeId || null,
            agentId: env.agent_id || null,
            agentStatus: env.agent_status || null,
            templateInstanceId: env.templateInstanceId || null,
            templateInstanceStatus: env.templateInstanceStatus || null,
            templateInstanceVersion: env.templateInstanceVersion || null,
            description: env.description || ''
        };
    });

    // ===== CLIENT TYPES (enriched async) =====
    vm.clientTypes = [];
    vm.commonClientTypes = [];   // ✅ pre-computed
    vm.specificClientTypes = [];   // ✅ pre-computed
    vm.loadingClientTypes = true;
    vm.templateInstancesByEnvId = {};

    // ===== MODEL =====
    vm.model = {
        name: '',
        description: '',
        clientTypeId: null
    };

    // ===== ENVIRONMENTS SELECTION =====
    vm.selectedEnvIds = [];
    vm.allSelected = false;
    vm.isSaving = false;

    require('../ClientEnvironmentMappings.js').bind(vm, null);

    // =====================================================================
    // HELPERS
    // =====================================================================

    vm.getEnvNameById = function (envId) {
        var env = vm.environments.find(function (e) { return e.id === envId; });
        return env ? env.name : envId;
    };

    vm.isEnvDisabledForClientType = function (envId) {
        if (!vm.model.clientTypeId) { return true; }
        var ct = vm.getSelectedClientType();
        if (!ct) { return true; }
        if (ct.isCommon) { return false; }
        return (ct.envIds || []).indexOf(envId) === -1;
    };

    vm.getSelectedClientType = function () {
        if (!vm.model.clientTypeId) { return null; }
        return vm.clientTypes.find(function (ct) { return ct.id === vm.model.clientTypeId; }) || null;
    };

    // ✅ Helpers basados en los arrays pre-computados — sin filter:{}
    vm.hasCommonClientTypes = function () { return vm.commonClientTypes.length > 0; };
    vm.hasSpecificClientTypes = function () { return vm.specificClientTypes.length > 0; };

    // =====================================================================
    // ✅ Pre-compute common/specific arrays después de cada asignación
    // =====================================================================

    function splitClientTypesByScope() {
        vm.commonClientTypes = vm.clientTypes.filter(function (ct) { return ct.isCommon === true; });
        vm.specificClientTypes = vm.clientTypes.filter(function (ct) { return ct.isCommon !== true; });
    }

    // =====================================================================
    // IP ADDRESS — CIDR validation
    // =====================================================================

    // =====================================================================
    // INIT
    // =====================================================================

    loadTemplateInstancesAndBuildClientTypes();
    loadPredefinedHeaders();

    // =====================================================================
    // LOAD TEMPLATE INSTANCES & BUILD CLIENT TYPES
    // =====================================================================

    function loadTemplateInstancesAndBuildClientTypes() {
        vm.loadingClientTypes = true;

        // ✅ Sin agentStatus — solo necesitamos template publicado
        var eligibleEnvs = vm.environments.filter(function (env) {
            return env.templateInstanceStatus === 'PUBLISHED' &&
                env.templateInstanceId;
        });

        if (eligibleEnvs.length === 0) {
            // ✅ Sin fallback a locals — lista vacía muestra el badge
            vm.clientTypes = [];
            splitClientTypesByScope();
            vm.loadingClientTypes = false;
            return;
        }

        var uniqueTemplateIds = [];
        var seen = {};
        eligibleEnvs.forEach(function (env) {
            if (!seen[env.templateInstanceId]) {
                seen[env.templateInstanceId] = true;
                uniqueTemplateIds.push(env.templateInstanceId);
            }
        });

        var fetchPromises = uniqueTemplateIds.map(function (tid) {
            return TemplateInstanceService.getTemplateInstanceById(tid)
                .then(function (response) { return response.data; })
                .catch(function (err) {
                    console.error('Error loading template instance:', tid, err);
                    return null;
                });
        });

        $q.all(fetchPromises).then(function (results) {
            var validTemplates = results.filter(function (t) { return t != null; });

            if (validTemplates.length === 0) {
                // ✅ Sin fallback a locals — lista vacía muestra el badge
                vm.clientTypes = [];
                splitClientTypesByScope();
                vm.loadingClientTypes = false;
                return;
            }

            var templateToEnvIds = {};
            eligibleEnvs.forEach(function (env) {
                if (!templateToEnvIds[env.templateInstanceId]) {
                    templateToEnvIds[env.templateInstanceId] = [];
                }
                templateToEnvIds[env.templateInstanceId].push(env.id);
            });

            var templateById = {};
            validTemplates.forEach(function (ti) { templateById[ti.id] = ti; });
            eligibleEnvs.forEach(function (env) {
                var ti = templateById[env.templateInstanceId];
                if (ti) { vm.templateInstancesByEnvId[env.id] = ti; }
            });

            vm.clientTypes = buildAllClientTypes(validTemplates, eligibleEnvs, templateToEnvIds);
            splitClientTypesByScope();

            console.log('✅ Client types loaded:', vm.clientTypes.length,
                '(common:', vm.commonClientTypes.length,
                ', specific:', vm.specificClientTypes.length, ')');

            vm.loadingClientTypes = false;
        });
    }

    function buildAllClientTypes(templateInstances, eligibleEnvs, templateToEnvIds) {
        if (!templateInstances || templateInstances.length === 0) { return []; }

        var sorted = templateInstances.slice().sort(function (a, b) {
            var vA = a.version || a.templateVersion || '0';
            var vB = b.version || b.templateVersion || '0';
            return vB.localeCompare(vA, undefined, { numeric: true });
        });

        var ctMap = {};
        sorted.forEach(function (ti) {
            var envIds = templateToEnvIds[ti.id] || [];
            var cts = extractClientTypes(ti);
            cts.forEach(function (ct) {
                if (!ctMap[ct.id]) {
                    ctMap[ct.id] = angular.extend({}, ct, { envIds: [] });
                }
                envIds.forEach(function (envId) {
                    if (ctMap[ct.id].envIds.indexOf(envId) === -1) {
                        ctMap[ct.id].envIds.push(envId);
                    }
                });
            });
        });

        var allEligibleEnvIds = eligibleEnvs.map(function (e) { return e.id; });

        var result = [];
        Object.keys(ctMap).forEach(function (id) {
            var ct = ctMap[id];
            var isCommon = allEligibleEnvIds.every(function (envId) {
                return ct.envIds.indexOf(envId) !== -1;
            });
            result.push(angular.extend({}, ct, { isCommon: isCommon }));
        });

        return result.sort(function (a, b) {
            if (a.isCommon && !b.isCommon) { return -1; }
            if (!a.isCommon && b.isCommon) { return 1; }
            return (a.name || '').toLowerCase().localeCompare((b.name || '').toLowerCase());
        });
    }

    function extractClientTypes(templateInstance) {
        try {
            var config = templateInstance.templateConfig;
            if (!config || !config.client_types) { return []; }
            return config.client_types.filter(function (ct) { return ct.enabled !== false; });
        } catch (e) {
            return [];
        }
    }

    // =====================================================================
    // WATCH clientTypeId — wipe environments on change
    // =====================================================================

    $scope.$watch('vm.model.clientTypeId', function (newVal, oldVal) {
        if (newVal === oldVal) { return; }
        vm.selectedEnvIds = [];
        vm.allSelected = false;
    });

    // =====================================================================
    // ENVIRONMENT SELECTION
    // =====================================================================

    vm.toggleEnv = function (envId) {
        if (vm.isEnvDisabledForClientType(envId)) { return; }
        var idx = vm.selectedEnvIds.indexOf(envId);
        if (idx > -1) { vm.selectedEnvIds.splice(idx, 1); }
        else { vm.selectedEnvIds.push(envId); }
        updateAllSelectedState();
    };

    vm.isEnvSelected = function (envId) {
        return vm.selectedEnvIds.indexOf(envId) > -1;
    };

    vm.toggleSelectAll = function () {
        var enabledEnvIds = vm.environments
            .filter(function (env) { return !vm.isEnvDisabledForClientType(env.id); })
            .map(function (env) { return env.id; });

        if (vm.allSelected) {
            vm.selectedEnvIds = [];
            vm.allSelected = false;
        } else {
            vm.selectedEnvIds = enabledEnvIds.slice();
            vm.allSelected = enabledEnvIds.length > 0;
        }
    };

    function updateAllSelectedState() {
        var enabledEnvs = vm.environments.filter(function (env) {
            return !vm.isEnvDisabledForClientType(env.id);
        });
        vm.allSelected = enabledEnvs.length > 0 &&
            enabledEnvs.every(function (env) { return vm.selectedEnvIds.indexOf(env.id) > -1; });
    }

    // =====================================================================
    // PREDEFINED HEADERS
    // =====================================================================

    function loadPredefinedHeaders() {
        ReferenceDataService.getReferenceData('HTTP_HEADER_TYPE')
            .then(function (response) {
                vm.predefinedHeaders = response.data || [];
            })
            .catch(function (error) {
                console.error('Error loading HTTP headers:', error);
                vm.predefinedHeaders = [];
            });
    }

    // =====================================================================
    // FORM VALIDATION
    // =====================================================================

    vm.isFormValid = function () {
        var isNameValid = vm.model.name && vm.model.name.trim() !== '';
        var isTypeValid = !!vm.model.clientTypeId;
        var isDescValid = vm.model.description && vm.model.description.trim() !== '';
        return isNameValid && isTypeValid && isDescValid && vm.invalidMappingEnvironments().length === 0;
    };

    // =====================================================================
    // CANCEL
    // =====================================================================

    vm.cancel = function () { $mdDialog.cancel('cancel'); };

    // =====================================================================
    // CREATE CLIENT
    // =====================================================================

    vm.createNewClient = function () {
        if (vm.isSaving || !vm.isFormValid()) { return; }

        vm.isSaving = true;

        var clientType = vm.clientTypes.find(function (t) { return t.id === vm.model.clientTypeId; });
        if (!clientType) {
            console.error('Client type not found');
            vm.isSaving = false;
            return;
        }

        var dto = {
            name: (vm.model.name || '').trim(),
            description: (vm.model.description || '').trim(),
            enabled: false,
            type: {
                id: vm.model.clientTypeId,
                type: clientType.name || ''
            },
            environments: vm.environments.map(function (env) {
                return {
                    id: env.id,
                    name: env.name,
                    enabled: vm.selectedEnvIds.indexOf(env.id) > -1,
                    clientMappings: vm.environmentMappingPayload(env.id)
                };
            })
        };

        ClientService.createClient(profile.id, dto)
            .then(function (response) {
                $mdDialog.hide(response.data);
            })
            .catch(function (err) {
                console.error('Error creating client:', err);
                vm.isSaving = false;
                var errorMessage = 'An error occurred while creating the client.';
                if (err.data && err.data.message) { errorMessage = err.data.message; }
                else if (err.statusText) { errorMessage = err.statusText; }
                dialogService.showErrorDialog('Create Failed', errorMessage);
            });
    };

    // =====================================================================
});